import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { GetLayoutQuery } from '../__generated__/graphql';
import { setCookie } from '../utils/cookies';

type UtmConfiguration = GetLayoutQuery['uTMConfiguration'];

export const useStoreQueryParams = (utmConfig: UtmConfiguration) => {
  const router = useRouter();

  useEffect(() => {
    const params = (utmConfig?.utmConfigurationBlock?.utmQueryParams ?? []).reduce<string[]>((acc, curr) =>
      curr?.queryParam
        ? [
          ...acc,
          curr.queryParam,
        ]
        : acc, []);

    for (const inputName of params) {
      const queryParamValue = router.query[inputName];
      if (queryParamValue) {
        const value = Array.isArray(queryParamValue) ? queryParamValue.join(',') : queryParamValue;
        setCookie(inputName, value, {
          expires: 1,
          sameSite: 'strict',
        });
      }
    }
  }, [router.query, utmConfig?.utmConfigurationBlock?.utmQueryParams]);
};
